import JsCookies from 'js-cookie';
import type { CookiesStatic } from 'js-cookie';

const BrowserCookies: Omit<CookiesStatic, 'getJSON'> & {
  getJSON<T = any>(name: string): T | null;
} = {
  defaults: JsCookies.defaults,

  get: JsCookies.get,

  set: JsCookies.set,

  remove: JsCookies.remove,

  withConverter: JsCookies.withConverter,

  getJSON<T = any>(name: string): T | null {
    try {
      const value = BrowserCookies.get(name);

      return value ? JSON.parse(value) : null;
    } catch (_e) {
      return null;
    }
  }
};

export default BrowserCookies;
